module.exports = __webpack_public_path__ + "fonts/GillSansProCyrillic-Medium.6f9774c3.woff";